import { WorkspaceShell } from "~/components/workspace-shell";
import { type BreadcrumbItem } from "~/types";
import type { ReactNode } from "react";

interface AppHeaderLayoutProps {
  children: ReactNode;
  breadcrumbs?: BreadcrumbItem[];
  hideHeaderOnMobile?: boolean;
  bottomBar?: ReactNode;
}

export default function AppHeaderLayout({
  children,
  breadcrumbs,
  hideHeaderOnMobile,
  bottomBar,
}: AppHeaderLayoutProps) {
  return (
    <WorkspaceShell
      breadcrumbs={breadcrumbs}
      hideHeaderOnMobile={hideHeaderOnMobile}
      bottomBar={bottomBar}
    >
      {children}
    </WorkspaceShell>
  );
}
